<div id="generate-report-button-container">
  <button
    id="generateReportButton"
    class="w-auto h-[40px] btn body-default-regular btn-primary"
    mat-raised-button
    color="primary"
    (click)="generateReport()"
  >
    Generate Report
  </button>
</div>
